// Meta Pixel Hook for tracking events
declare global {
  interface Window {
    fbq: (...args: any[]) => void
  }
}

// Initialize Meta Pixel
export function initMetaPixel() {
  if (typeof window === 'undefined') return

  // Check if already initialized
  if (window.fbq) return

  // Meta Pixel base code
  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  let n: any
  if (f.fbq) return
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v

  const s = b.getElementsByTagName(e)[0]
  s?.parentNode?.insertBefore(t, s)

  // Initialize with your Pixel ID
  window.fbq('init', '904375051696707')
}

// Track PageView
export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

// Track AddToCart
export function trackAddToCart(
  contentName?: string,
  value?: number,
  currency?: string,
) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: contentName || 'Cuidador Sin Caos',
      content_type: 'product',
      value: value || 9300,
      currency: currency || 'ARS',
    })
  }
}

// Track Purchase (for future use)
export function trackPurchase(value?: number, currency?: string) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Purchase', {
      value: value || 9300,
      currency: currency || 'ARS',
    })
  }
}

// Track InitiateCheckout (for future use)
export function trackInitiateCheckout(value?: number, currency?: string) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      value: value || 9300,
      currency: currency || 'ARS',
    })
  }
}
